import PropTypes from 'prop-types';
// @mui
import Container from '@mui/material/Container';
// routes
import { paths } from 'src/routes/paths';
// components
import { useSettingsContext } from 'src/components/settings';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';
//
import OpRegistrationReportForm from '../op-registration-report-form';

// ----------------------------------------------------------------------

export default function OpRegistrationReportView() {
  const settings = useSettingsContext();

  return (
    <Container maxWidth={settings.themeStretch ? false : 'xl'}>
      <CustomBreadcrumbs
        heading="Op Registration Report"
        links={[
          {
            name: 'Dashboard',
            href: paths.dashboard.root,
          },
          { name: 'Report' },
          { name: 'Op Registration' },
        ]}
        sx={{
          mb: { xs: 3, md: 5 },
        }}
      />

      <OpRegistrationReportForm />
    </Container>
  );
}
